module.exports = __webpack_public_path__ + "static/media/video-20-ru.a676bd70.webm";